export const AppConfig = {
  apiUrl: 'https://gowint.com',
  // apiUrl: 'http://localhost:3000',
  authDomainList: [
    'localhost',
    'gowint.com',
    'panel.gowint.com',
  ],
}
